(function () {
  // Homepage cart drawer. This is a deliberate, near-verbatim PORT of the
  // drawer-specific portion of assets/product-kindred-set.js (renderCartItems,
  // renderCartUpsell, renderCart, the upsell/qty/remove interaction handling,
  // and the express-checkout pristine-reset fix) — NOT a shared module. The
  // PDP's cart drawer was explicitly called out as the one that "does it
  // well" and Daniel asked not to change it, so this reuses the exact same
  // kp-cart-*/kp-cu-* markup and CSS (product-kindred-set.css is loaded on
  // this page too) rather than touching that file. Known tradeoff: this is
  // duplicated logic, not extracted — if the PDP's drawer behavior changes,
  // this file needs updating too. See project memory for the fuller note on
  // why a live extraction wasn't done in the same session as an urgent PDP
  // cart-drawer fix.
  var variantDataEl = document.getElementById('kp-variant-data');
  var addonDataEl   = document.getElementById('kp-addon-data');
  var drawer        = document.getElementById('kp-cart-drawer');
  var cartBtn       = document.getElementById('kh-cart-btn');
  if (!variantDataEl || !drawer || !cartBtn) return;

  var variants = JSON.parse(variantDataEl.textContent).variants;
  var addonRaw = addonDataEl ? JSON.parse(addonDataEl.textContent) : {};
  var extraCapVariants = addonRaw.extraCapVariants || [];

  var priceData = addonRaw.prices || {};
  var PRICES = {
    set: priceData.set || 69,
    extraCap: priceData.extraCap || 30,
    shipping: priceData.shipping || 10
  };

  var defaultColourInput = document.getElementById('kp-default-colour');
  var selectedColour = defaultColourInput ? defaultColourInput.value : 'Navy';

  var lastCart = null;
  var cartMutating = false;
  var lastFreeShipState = null;
  // Tracks whether "The Kindred Set" is already in the cart, for the
  // homepage set-card CTA's link/add/view-cart state — see applyCartState
  // and the SET CARD block near the end of this file.
  var setInCart = false;

  var expressEl = document.querySelector('.kp-cart-express');
  var expressPristineHTML = expressEl ? expressEl.innerHTML : null;

  function findSetVariant(colour, size) {
    return variants.find(function (v) { return v.option1 === colour && v.option2 === size; });
  }
  function findExtraCapVariant(size) {
    return extraCapVariants.find(function (v) { return v.size === size; });
  }
  function getExtraCapQtyInCart(cart, variantId) {
    if (!cart || !cart.items) return 0;
    var item = cart.items.find(function (i) { return i.variant_id === variantId; });
    return item ? item.quantity : 0;
  }
  function cartHasExtraCap(cart) {
    if (!cart || !cart.items) return false;
    var ids = extraCapVariants.map(function (v) { return v.id; });
    return cart.items.some(function (i) { return ids.indexOf(i.variant_id) !== -1 && i.quantity > 0; });
  }

  function renderCartItems(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return '<p class="kp-cart-empty">Your cart is empty.</p>';
    }

    var colourOrder = [];
    var byColour = {};
    cart.items.forEach(function (item) {
      var raw    = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var colour = raw.split(' / ')[0] || '';
      if (!byColour[colour]) { byColour[colour] = []; colourOrder.push(colour); }
      byColour[colour].push(item);
    });

    var typeRank = { 'The Kindred Set': 0, 'Extra Cap — Kids Sizes': 1, 'Extra Cap — Adult Size': 2 };
    var isExtraCapTitle = { 'Extra Cap — Kids Sizes': true, 'Extra Cap — Adult Size': true };

    // "Toddler (2–4 yrs)" -> "Toddler Cap (2–4 yrs)" — used for the kids
    // add-on line items' combined one-line name+size (see renderItem).
    function capLineName(sizeLabel) {
      var m = sizeLabel.match(/^(\S+)\s*(\(.*\))$/);
      return m ? (m[1] + ' Cap ' + m[2]) : (sizeLabel + ' Cap');
    }

    function renderItem(item) {
      var raw    = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var parts  = raw.split(' / ');
      var colour = parts[0] || '';
      var displayName, size;
      var isAddon = !!isExtraCapTitle[item.product_title];

      if (item.product_title === 'The Kindred Set') {
        displayName = 'The Kindred Set';
        size = parts[1] ? 'Adult & ' + parts[1] : '';
      } else if (item.product_title === 'Extra Cap — Adult Size') {
        // Add-on lines are named + sized in one line now ("Adult Cap
        // (12+ yrs)") instead of a separate name + colour + size stack —
        // was 3 lines tall per add-on, a real height cost with 3-4 items
        // in the cart. Deliberately drops "Extra" from the name: on an
        // already-in-the-cart line item it reads clean either way, and
        // "Extra Youth Cap" specifically risked implying the original Set
        // already included a youth cap (it may have shipped with a
        // toddler or adult second cap instead) — "Youth Cap (5–11 yrs)"
        // just states what this line actually is, no ambiguity. Colour
        // dropped too (Navy-only at launch; revisit if a second
        // colourway ships and these lines need to disambiguate again).
        displayName = 'Adult Cap (12+ yrs)';
        size = '';
      } else {
        displayName = parts[1] ? capLineName(parts[1]) : 'Extra Cap';
        size = '';
      }

      // Ported from product-kindred-set.js — the module chip overlays
      // pendingExtras on the real quantity for instant feedback, so it can
      // race ahead of this line during a rapid tap burst (chip at 5, this
      // line frozen at 1 until the queued commits resolve, then it jumps)
      // — that freeze-then-jump is what read as laggy. Overlaying the same
      // delta here keeps both numbers moving together on every tap.
      var addonSizeKey = item.product_title === 'Extra Cap — Adult Size' ? 'Adult (12+ yrs)' : (isAddon ? parts[1] : null);
      var displayQty = (isAddon && addonSizeKey && pendingExtras[addonSizeKey])
        ? Math.max(0, item.quantity + pendingExtras[addonSizeKey])
        : item.quantity;
      var isSet = item.product_title === 'The Kindred Set';
      var img = item.image
        ? '<img class="kp-cart-img" src="' + item.image + '" alt="" width="72" height="72" loading="eager">'
        : '<div class="kp-cart-img kp-cart-img--ph"></div>';

      var priceHtml = '$' + (item.final_line_price / 100).toFixed(0);

      return '<div class="kp-cart-item' + (isAddon ? ' kp-cart-item--addon' : '') + '">'
        + img
        + '<div class="kp-cart-item-info">'
        +   '<div class="kp-cart-item-top">'
        +     '<p class="kp-cart-item-name">' + displayName + '</p>'
        +     '<p class="kp-cart-item-price">' + priceHtml + '</p>'
        +   '</div>'
        +   (size ? '<p class="kp-cart-item-variant">' + size + '</p>' : '')
        +   '<div class="kp-cart-item-bot">'
        +     '<div class="kp-cart-qty">'
        +       '<button class="kp-qty-btn" data-key="' + item.key + '" data-delta="-1" data-set="' + isSet + '" type="button">&#x2212;</button>'
        +       '<span class="kp-qty-val">' + displayQty + '</span>'
        +       '<button class="kp-qty-btn" data-key="' + item.key + '" data-delta="1" type="button">+</button>'
        +     '</div>'
        +     '<button class="kp-cart-remove" data-key="' + item.key + '" data-set="' + isSet + '" type="button" aria-label="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M216 50H40a6 6 0 0 0 0 12h10v146a14 14 0 0 0 14 14h128a14 14 0 0 0 14-14V62h10a6 6 0 0 0 0-12m-22 158a2 2 0 0 1-2 2H64a2 2 0 0 1-2-2V62h132ZM82 24a6 6 0 0 1 6-6h80a6 6 0 0 1 0 12H88a6 6 0 0 1-6-6"/></svg></button>'
        +   '</div>'
        + '</div>'
        + '</div>';
    }

    return colourOrder.map(function (colour, groupIdx) {
      var sorted = byColour[colour].slice().sort(function (a, b) {
        var ra = typeRank[a.product_title] != null ? typeRank[a.product_title] : 99;
        var rb = typeRank[b.product_title] != null ? typeRank[b.product_title] : 99;
        return ra - rb;
      });
      var divider = groupIdx > 0 ? '<hr class="kp-cart-divider">' : '';
      return divider + sorted.map(renderItem).join('');
    }).join('');
  }

  var SIZE_ORDER = ['Toddler (2–4 yrs)', 'Youth (5–11 yrs)', 'Adult (12+ yrs)'];

  function renderAddonModule(cart) {
    var chipsHtml = SIZE_ORDER.map(function (size) {
      var v = findExtraCapVariant(size);
      if (!v) return '';
      var qty = Math.max(0, extraBaselineQty(cart, size) + (pendingExtras[size] || 0));
      var soldOut = v.available === false;
      var shortName = size.split(' (')[0];
      var ageLabel = '(' + size.split(' (')[1];
      return '<div class="kp-xcap-chip kp-xcap-chip-f' + (soldOut ? ' is-soldout' : '') + (qty > 0 ? ' has-qty' : '') + '" data-xcap-size="' + size + '">'
        + '<div class="kp-chip-f-name">'
        +   '<span class="kp-chip-f-size">' + shortName + '</span>'
        +   '<span class="kp-chip-f-age">' + ageLabel + '</span>'
        + '</div>'
        + (soldOut
          ? '<div class="kp-xcap-soldout-label">Sold out</div>'
          : '<div class="kp-xcap-stepper-f">'
            +   '<button class="kp-xcap-btn kp-xcap-minus" data-xcap-variant="' + v.id + '" data-xcap-delta="-1" type="button" aria-label="Remove one ' + size + ' extra cap"' + (qty === 0 ? ' disabled' : '') + '>&#x2212;</button>'
            +   '<span class="kp-xcap-qty">' + qty + '</span>'
            +   '<button class="kp-xcap-btn kp-xcap-plus" data-xcap-variant="' + v.id + '" data-xcap-delta="1" type="button" aria-label="Add one ' + size + ' extra cap">+</button>'
            + '</div>')
        + '</div>';
    }).join('');

    // No CTA here — this drawer's chip taps commit immediately (see the
    // click handler), since the cart list is right there above the tap.

    // Badge reads the real committed cart, never the staged/pending state.
    // Baked to the LAST known state (not the fresh one) so the very first
    // render after a genuine unlock is an observable attribute change for
    // syncFreeShipBadges to animate, rather than being born already-unlocked.
    var badgeBaked = badgeWasUnlocked === null ? cartHasExtraCap(cart) : badgeWasUnlocked;
    // Always the drawer here (homepage has no on-page addon module) — the
    // badge is a real button, greyed out while locked, that spotlights the
    // chips below it on tap. Same mechanism as product-kindred-set.js's
    // spotlightXcapChips, ported.
    var badgeHtml = '<button type="button" class="kp-xcap-badge kp-xcap-badge--interactive' + (badgeBaked ? ' is-unlocked' : '') + '">'
      + '<span class="kp-xcap-badge-shine" aria-hidden="true"></span>'
      + 'Free shipping'
      + '<span class="kp-xcap-badge-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span>'
      + '</button>';

    return '<div class="kp-xcap">'
      + '<div class="kp-xcap-head">'
      +   '<div class="kp-xcap-head-top">'
      +     '<p class="kp-xcap-title">Build your Kindred family.</p>'
      +     badgeHtml
      +   '</div>'
      +   '<ul class="kp-xcap-bullets">'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Add any extra cap for $' + PRICES.extraCap + '.</span></li>'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Free shipping when you add any extra cap.</span></li>'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Perfect for the other parent or siblings.</span></li>'
      +   '</ul>'
      + '</div>'
      + '<div class="kp-xcap-chips">' + chipsHtml + '</div>'
      + '</div>';
  }

  var badgeWasUnlocked = null;

  // Flips every .kp-xcap-badge's unlocked state to match the real cart,
  // animating only on a genuine locked<->unlocked edge.
  function syncFreeShipBadges(cart) {
    var unlocked = cartHasExtraCap(cart);
    // The moment it's genuinely unlocked, clear any active spotlight — the
    // whole point was getting here, so it has nothing left to point at.
    if (unlocked) dismissXcapSpotlight();
    // :not(.kh-set-included-badge) excludes the homepage's own "Adult Cap
    // Included" badge — it reuses .kp-xcap-badge purely for the visual
    // (shine/tick), but is a permanent fact, not a free-shipping-unlock
    // indicator, so it must never be toggled by this function. Before this
    // exclusion, opening the cart drawer (any cart mutation at all) reset
    // it to is-unlocked=false, killing its shine/tick.
    var badges = document.querySelectorAll('.kp-xcap-badge:not(.kh-set-included-badge)');
    if (badgeWasUnlocked === null) {
      badges.forEach(function (b) { b.classList.toggle('is-unlocked', unlocked); });
      badgeWasUnlocked = unlocked;
      return;
    }
    if (unlocked === badgeWasUnlocked) return;
    badges.forEach(function (b) { void b.offsetWidth; });
    badges.forEach(function (b) { b.classList.toggle('is-unlocked', unlocked); });
    badgeWasUnlocked = unlocked;
  }

  // Ported from product-kindred-set.js's spotlightXcapChips/dismissXcapSpotlight
  // — see that file for the full reasoning (why this needs its own
  // drawer-local overlay rather than a page-level one). #kp-cart-addon-mount
  // is always this page's own drawer module.
  function spotlightXcapChips() {
    var drawer = document.getElementById('kp-cart-drawer');
    var chipsEl = document.querySelector('#kp-cart-addon-mount .kp-xcap-chips');
    if (!drawer || !chipsEl) return;

    var overlay = document.getElementById('kp-xcap-spotlight-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'kp-xcap-spotlight-overlay';
      overlay.className = 'kp-xcap-spotlight-overlay';
      overlay.addEventListener('click', dismissXcapSpotlight);
      drawer.appendChild(overlay);
    }

    var label = document.getElementById('kp-xcap-spotlight-label');
    if (!label) {
      label = document.createElement('div');
      label.id = 'kp-xcap-spotlight-label';
      label.className = 'kp-xcap-spotlight-label';
      label.textContent = 'Choose an extra cap for free shipping';
      chipsEl.appendChild(label);
    }

    overlay.classList.add('is-active');
    chipsEl.classList.add('kp-xcap-chips--spotlight');
    label.classList.add('is-visible');
  }

  function dismissXcapSpotlight() {
    var overlay = document.getElementById('kp-xcap-spotlight-overlay');
    var label = document.getElementById('kp-xcap-spotlight-label');
    var chipsEl = document.querySelector('#kp-cart-addon-mount .kp-xcap-chips');
    if (overlay) overlay.classList.remove('is-active');
    if (label) label.classList.remove('is-visible');
    if (chipsEl) chipsEl.classList.remove('kp-xcap-chips--spotlight');
  }

  function updateBadge(cart) {
    var n = (cart && cart.item_count) ? cart.item_count : 0;
    var badge = cartBtn.querySelector('.kh-cart-count');
    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'kh-cart-count';
        cartBtn.appendChild(badge);
      }
      badge.textContent = n;
    } else if (badge) {
      badge.remove();
    }
    cartBtn.classList.toggle('kh-cart-btn--has-items', n > 0);
    cartBtn.setAttribute('aria-label', 'Cart (' + n + ' items)');
  }

  function applyCartState(cart) {
    updateBadge(cart);
    setInCart = !!(cart && cart.items && cart.items.some(function (item) {
      return item.product_title === 'The Kindred Set';
    }));
    syncSetCtaState();
  }

  // Ported from product-kindred-set.js — see its own comment for why this
  // exists: a flat CSS min-height on #kp-cart-body reserved room for 2
  // items even with only 1 in the cart, and that dead space was what
  // pushed the trust badges/Checkout below the fold on a modest browser
  // window. Sets the floor from the real measured height of
  // min(itemCount, 2) items instead.
  function syncCartBodyMinHeight() {
    var bodyEl = document.getElementById('kp-cart-body');
    if (!bodyEl) return;
    var items = bodyEl.querySelectorAll('.kp-cart-item');
    if (!items.length) { bodyEl.style.minHeight = ''; return; }
    var wanted = Math.min(items.length, 2);
    var total = 0;
    for (var i = 0; i < wanted; i++) total += items[i].getBoundingClientRect().height;
    bodyEl.style.minHeight = Math.ceil(total) + 'px';
  }

  function renderCart(cart) {
    lastCart = cart;
    var bodyEl      = document.getElementById('kp-cart-body');
    var addonMount  = document.getElementById('kp-cart-addon-mount');
    var subtotalEl  = document.getElementById('kp-cart-subtotal');
    var cartIsEmpty = !cart || !cart.items || !cart.items.length;
    // Only the item list scrolls — the module renders into its own
    // fixed container below it so it never gets pushed down/clipped.
    if (bodyEl) bodyEl.innerHTML = renderCartItems(cart);
    syncCartBodyMinHeight();
    if (addonMount) addonMount.innerHTML = cartIsEmpty ? '' : renderAddonModule(cart);
    if (subtotalEl && cart) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(0);
    syncFreeShipBadges(cart);

    var shipEl = document.getElementById('kp-cart-ship-line');
    var shipFillEl = document.getElementById('kp-cart-ship-fill');
    var shipWrapEl = document.getElementById('kp-cart-ship');
    var subtotalLabelEl = document.getElementById('kp-cart-subtotal-label');
    if (shipEl && cart) {
      var hasExtra = cartHasExtraCap(cart);
      lastFreeShipState = hasExtra;
      // Not-yet-unlocked state shows nothing for now (redesign pending),
      // no animation either.
      if (shipWrapEl) shipWrapEl.hidden = !hasExtra;
      if (hasExtra) {
        shipEl.innerHTML = '<span class="kp-ship-tick">'
          + '<svg width="13" height="13" viewBox="0 0 13 13"><path d="M2.5 6.5l3 3 5-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '</span> Free shipping!';
        shipEl.classList.add('kp-cart-ship-line--unlocked');
      }
      if (subtotalLabelEl) subtotalLabelEl.textContent = hasExtra ? 'Total' : 'Subtotal';
      if (shipFillEl) {
        shipFillEl.style.width = hasExtra ? '100%' : '0%';
        shipFillEl.classList.toggle('kp-cart-ship-fill--unlocked', hasExtra);
      }
    }

    var drawerEl = document.getElementById('kp-cart-drawer');
    if (drawerEl) {
      var isEmpty = !cart || !cart.items || !cart.items.length;
      drawerEl.classList.toggle('is-empty', isEmpty);
    }
  }

  function openCartDrawer(cart) {
    renderCart(cart);
    updateBadge(cart);
    if (expressEl && expressPristineHTML != null) {
      expressEl.innerHTML = expressPristineHTML;
    }
    var overlay = document.getElementById('kp-cart-overlay');
    if (overlay) overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 400);
  }

  function closeCartDrawer() {
    var overlay = document.getElementById('kp-cart-overlay');
    if (overlay) overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var cartCloseBtn  = document.getElementById('kp-cart-close');
  var cartOverlayEl = document.getElementById('kp-cart-overlay');
  if (cartCloseBtn)  cartCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlayEl) cartOverlayEl.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });

  cartBtn.addEventListener('click', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { openCartDrawer(cart); })
      .catch(function () {});
  });

  function mergeCartAdd(addedData) {
    if (!lastCart || !addedData || !addedData.items || !addedData.items.length) return null;
    var cart = JSON.parse(JSON.stringify(lastCart));
    addedData.items.forEach(function (newItem) {
      var found = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === newItem.variant_id) {
          cart.items[i].quantity += newItem.quantity;
          cart.items[i].line_price = cart.items[i].price * cart.items[i].quantity;
          cart.items[i].final_line_price = cart.items[i].price * cart.items[i].quantity;
          found = true;
          break;
        }
      }
      if (!found) cart.items.push(JSON.parse(JSON.stringify(newItem)));
      cart.item_count = (cart.item_count || 0) + newItem.quantity;
      cart.total_price = (cart.total_price || 0) + newItem.price * newItem.quantity;
    });
    lastCart = cart;
    return cart;
  }

  function optimisticCartChange(key, newQty) {
    if (!lastCart) return null;
    var cart = JSON.parse(JSON.stringify(lastCart));
    var idx = -1;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) { idx = i; break; }
    }
    if (idx === -1) return null;
    var item = cart.items[idx];
    var oldQty = item.quantity;
    if (newQty <= 0) {
      cart.items.splice(idx, 1);
      cart.item_count -= oldQty;
      cart.total_price -= item.price * oldQty;
    } else {
      var diff = newQty - oldQty;
      item.quantity = newQty;
      item.line_price = item.price * newQty;
      item.final_line_price = item.price * newQty;
      cart.item_count += diff;
      cart.total_price += item.price * diff;
    }
    return cart;
  }

  function showDrawerError(msg) {
    var body = document.getElementById('kp-cart-body');
    if (!body) return;
    var p = document.createElement('p');
    p.className = 'kp-cart-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    body.insertBefore(p, body.firstChild);
    setTimeout(function () { if (p.parentElement) p.remove(); }, 5000);
  }

  // A chip tap never writes to /cart directly — it only stages a delta
  // against whatever's actually live in the cart, mirroring the PDP's
  // module (assets/product-kindred-set.js). The only real write happens
  // in commitPendingExtras, via the "Add/Update Cart" button, so there's
  // always something on screen confirming a tap actually did something.
  var pendingExtras = { 'Toddler (2–4 yrs)': 0, 'Youth (5–11 yrs)': 0, 'Adult (12+ yrs)': 0 };

  function extraBaselineQty(cart, size) {
    var v = findExtraCapVariant(size);
    if (!v) return 0;
    return getExtraCapQtyInCart(cart, v.id);
  }

  function pendingExtrasTotal() {
    var total = 0;
    SIZE_ORDER.forEach(function (size) { total += pendingExtras[size] || 0; });
    return total;
  }

  function anyPendingExtraChange() {
    return SIZE_ORDER.some(function (size) { return (pendingExtras[size] || 0) !== 0; });
  }

  function resetPendingExtras() {
    SIZE_ORDER.forEach(function (size) { pendingExtras[size] = 0; });
  }

  // skipRender: commitPendingExtras (called right after this, see the click
  // handler) does its own optimistic renderCart — without this flag every
  // tap tore down and rebuilt the whole cart body + module TWICE in a row
  // for the same resulting numbers, which read as laggy/unresponsive under
  // rapid tapping. Only skip when commitPendingExtras is actually about to
  // run right behind this call (see the click handler's willCommitNow) —
  // if a commit's already in flight, commitPendingExtras will no-op and
  // this render is the only feedback the tap gets.
  function changePendingExtraQty(size, delta, skipRender) {
    if (!size) return;
    var baseline = extraBaselineQty(lastCart, size);
    var newDelta = Math.max(-baseline, (pendingExtras[size] || 0) + delta);
    pendingExtras[size] = newDelta;
    if (typeof gtag === 'function') {
      gtag('event', delta > 0 ? 'addon_chip_tap' : 'addon_removed', { event_category: 'ecommerce', value: baseline + newDelta });
    }
    if (skipRender) return;
    renderCart(lastCart);
  }

  function setXcapCtaBusy(busy) {
    document.querySelectorAll('.kp-xcap-set-cta').forEach(function (btn) {
      btn.disabled = busy;
      btn.classList.toggle('is-adding', busy);
    });
  }

  // Sizes with no existing line are batched into a single /cart/add.js
  // call; sizes that already have a line go through /cart/change.js one
  // at a time. IMPORTANT: /cart/change.js's "id" must be the real line
  // *key* (format "variantId:propertiesHash") or a 1-based line index — a
  // bare variant ID is silently reinterpreted as a line index and 400s
  // the moment the cart has more lines than that index.
  // Applies `changes` to a cloned cart for an immediate, optimistic render
  // — the cart list should update the instant the tap happens, not after
  // the add/change/reconcile round-trip resolves. Confirmed (or rolled
  // back) once the real request finishes.
  function buildOptimisticCart(baseCart, changes) {
    var cart = baseCart ? JSON.parse(JSON.stringify(baseCart)) : { items: [], item_count: 0, total_price: 0 };
    changes.forEach(function (c) {
      var idx = cart.items.findIndex(function (i) { return i.variant_id === c.variantId; });
      if (idx === -1) {
        if (c.newQty <= 0) return;
        var isAdultAddon = c.size === 'Adult (12+ yrs)';
        var linePrice = PRICES.extraCap * 100 * c.newQty;
        var optimisticItem = {
          product_title: isAdultAddon ? 'Extra Cap — Adult Size' : 'Extra Cap — Kids Sizes',
          variant_title: isAdultAddon ? 'Navy' : ('Navy / ' + c.size),
          quantity: c.newQty,
          price: PRICES.extraCap * 100,
          final_line_price: linePrice,
          line_price: linePrice,
          key: 'optimistic-' + c.variantId,
          variant_id: c.variantId,
          image: null
        };
        cart.items.push(optimisticItem);
        cart.item_count = (cart.item_count || 0) + c.newQty;
        cart.total_price = (cart.total_price || 0) + linePrice;
      } else {
        var item = cart.items[idx];
        var oldQty = item.quantity;
        var diff = c.newQty - oldQty;
        if (c.newQty <= 0) {
          cart.items.splice(idx, 1);
          cart.item_count -= oldQty;
          cart.total_price -= item.price * oldQty;
        } else {
          item.quantity = c.newQty;
          item.line_price = item.price * c.newQty;
          item.final_line_price = item.price * c.newQty;
          cart.item_count += diff;
          cart.total_price += item.price * diff;
        }
      }
    });
    return cart;
  }

  function commitPendingExtras() {
    if (cartMutating || !anyPendingExtraChange()) return;

    var changes = SIZE_ORDER.map(function (size) {
      var delta = pendingExtras[size] || 0;
      if (!delta) return null;
      var v = findExtraCapVariant(size);
      if (!v) return null;
      var baseline = extraBaselineQty(lastCart, size);
      return { size: size, variantId: v.id, baseline: baseline, newQty: Math.max(0, baseline + delta) };
    }).filter(Boolean);
    if (!changes.length) return;

    var netDelta = pendingExtrasTotal();
    var hadExtraBefore = cartHasExtraCap(lastCart);
    var toAdd = changes.filter(function (c) { return c.baseline === 0 && c.newQty > 0; });
    var toChange = changes.filter(function (c) { return c.baseline > 0; });

    // Clear the staged deltas now, before the optimistic render — it
    // already bakes `changes` into its baseline, so leaving pendingExtras
    // non-zero here double-counts them (chip briefly shows the tap
    // applied twice before snapping back once the real commit resolves).
    // Restored on failure below.
    resetPendingExtras();

    // Instant feedback — render the guessed end-state right away, before
    // any network call has even fired.
    var optimisticCart = buildOptimisticCart(lastCart, changes);
    lastCart = optimisticCart;
    applyCartState(optimisticCart);
    renderCart(optimisticCart);

    cartMutating = true;
    setXcapCtaBusy(true);

    var chain = Promise.resolve();

    if (toAdd.length) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: toAdd.map(function (c) { return { id: c.variantId, quantity: c.newQty }; }) })
        }).then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(function (data) { throw new Error(data.description || data.message || 'Could not add to cart.'); });
        });
      });
    }

    toChange.forEach(function (c) {
      chain = chain.then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          lastCart = cart;
          var line = cart.items.find(function (i) { return i.variant_id === c.variantId; });
          if (!line) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: c.newQty })
          }).then(function (res) { return res.json(); });
        });
      });
    });

    chain
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        cartMutating = false;
        setXcapCtaBusy(false);
        if (typeof gtag === 'function') {
          gtag('event', netDelta > 0 ? 'addon_chip_tap' : 'addon_removed', { event_category: 'ecommerce', value: netDelta });
          if (netDelta > 0 && !hadExtraBefore) gtag('event', 'free_shipping_unlocked', { event_category: 'ecommerce' });
        }
        lastCart = cart;
        applyCartState(cart);
        renderCart(cart);
        // Taps are never blocked by cartMutating while a commit is in
        // flight (see the click handlers) — a rapid tapper can stage more
        // addon changes, or queue cart-line qty/remove taps, during this
        // exact window. Flush whichever is pending now instead of leaving
        // it stuck with nothing left to trigger a commit.
        flushPendingCartWork();
      })
      .catch(function (err) {
        cartMutating = false;
        setXcapCtaBusy(false);
        showDrawerError(err && err.message ? err.message : 'Could not update cart — please try again.');
        // Restore the staged deltas we cleared before the optimistic
        // render, so the chips still show what they tapped.
        changes.forEach(function (c) { pendingExtras[c.size] = c.newQty - c.baseline; });
        // lastCart is currently the optimistic guess — roll back to the real cart.
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          lastCart = real;
          applyCartState(real);
          renderCart(real);
          flushPendingCartWork();
        });
      });
  }

  // Cart-line qty (+/-) and remove taps share this queue, and share the
  // same cartMutating lock with commitPendingExtras above — /cart writes
  // aren't safe to fire concurrently, so only one mutation is ever truly
  // in flight. What used to happen on a rapid tap was that every tap
  // landing while cartMutating was true got silently dropped (no visual
  // response at all). Now the optimistic UI update always applies
  // instantly, and the *commit* is queued instead of dropped: queued taps
  // get coalesced to a line's latest desired quantity and flushed by
  // flushPendingCartWork the moment the in-flight request resolves.
  var pendingQtyByKey = {};

  function queueQtyCommit(key, targetQty) {
    pendingQtyByKey[key] = targetQty;
    if (!cartMutating) runNextQtyCommit();
  }

  function runNextQtyCommit() {
    var keys = Object.keys(pendingQtyByKey);
    if (!keys.length) return;
    var key = keys[0];
    var targetQty = pendingQtyByKey[key];
    delete pendingQtyByKey[key];
    cartMutating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: targetQty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      cartMutating = false;
      if (!cart || !cart.items) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          lastCart = real; applyCartState(real); renderCart(real);
          showDrawerError('Could not update cart — please try again.');
          flushPendingCartWork();
        });
        return;
      }
      lastCart = cart;
      applyCartState(cart);
      renderCart(cart);
      flushPendingCartWork();
    }).catch(function () {
      cartMutating = false;
      flushPendingCartWork();
    });
  }

  // Single drain point called at the end of every cart mutation — checks
  // the qty/remove queue first, then staged addon extras, and fires
  // whichever is pending.
  function flushPendingCartWork() {
    if (Object.keys(pendingQtyByKey).length) { runNextQtyCommit(); return; }
    if (anyPendingExtraChange()) commitPendingExtras();
  }

  function enforceColourConstraint(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var setColours = [];
    cart.items.forEach(function (i) {
      if (i.product_title === 'The Kindred Set') {
        var c = i.variant_title ? i.variant_title.split(' / ')[0] : null;
        if (c && setColours.indexOf(c) === -1) setColours.push(c);
      }
    });
    var toRemove = [];
    cart.items.forEach(function (i) {
      if (i.product_title === 'Extra Cap — Kids Sizes' || i.product_title === 'Extra Cap — Adult Size') {
        var c = i.variant_title ? i.variant_title.split(' / ')[0] : null;
        if (c && setColours.indexOf(c) === -1) toRemove.push(i.key);
      }
    });
    if (!toRemove.length) return Promise.resolve(cart);
    return toRemove.reduce(function (p, key) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve())
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); });
  }

  function clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyCartState(cart);
        renderCart(cart);
      })
      .catch(function () {});
  }

  function removeSetItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          applyCartState(real); renderCart(real);
          showDrawerError('Could not update cart — please try again.');
        });
        return;
      }
      var setsRemain = cart.items && cart.items.some(function (item) {
        return item.product_title === 'The Kindred Set';
      });
      if (!setsRemain) {
        clearCart();
      } else {
        enforceColourConstraint(cart).then(function (cleaned) {
          applyCartState(cleaned);
          renderCart(cleaned);
        });
      }
    }).catch(function () {});
  }

  var cartBodyEl = document.getElementById('kp-cart-body');
  if (cartBodyEl) {
    cartBodyEl.addEventListener('click', function (e) {
      var t = e.target;
      var qtyBtn = null, removeBtn = null;
      while (t && t !== cartBodyEl) {
        if (t.classList && t.classList.contains('kp-qty-btn'))     { qtyBtn = t; break; }
        if (t.classList && t.classList.contains('kp-cart-remove')) { removeBtn = t; break; }
        t = t.parentElement;
      }

      if (qtyBtn) {
        var key    = qtyBtn.dataset.key;
        var delta  = parseInt(qtyBtn.dataset.delta, 10);
        var isSet  = qtyBtn.dataset.set === 'true';
        var valEl  = qtyBtn.parentElement.querySelector('.kp-qty-val');
        var newQty = Math.max(0, parseInt(valEl ? valEl.textContent : '1', 10) + delta);
        if (newQty === 0 && isSet) {
          removeSetItem(key);
        } else {
          // Optimistic update always applies instantly, never gated on
          // cartMutating — see queueQtyCommit for why (a rapid tapper used
          // to see maybe 1 in 5 taps register at all).
          var optQty = optimisticCartChange(key, newQty);
          if (optQty) { lastCart = optQty; applyCartState(optQty); renderCart(optQty); }
          queueQtyCommit(key, newQty);
        }
      }
      if (removeBtn) {
        var rKey   = removeBtn.dataset.key;
        var rIsSet = removeBtn.dataset.set === 'true';
        if (rIsSet) {
          removeSetItem(rKey);
        } else {
          var optRem = optimisticCartChange(rKey, 0);
          if (optRem) { lastCart = optRem; applyCartState(optRem); renderCart(optRem); }
          queueQtyCommit(rKey, 0);
        }
      }
    });
  }

  // Size-guide popup + close (kp-pg-sg-*), reused inside the upsell rows.
  document.addEventListener('click', function (e) {
    var xcapBadgeBtn = e.target.closest ? e.target.closest('.kp-xcap-badge--interactive') : null;
    if (xcapBadgeBtn) {
      if (!xcapBadgeBtn.classList.contains('is-unlocked')) spotlightXcapChips();
      return;
    }

    var xcapBtn = e.target.closest ? e.target.closest('.kp-xcap-btn') : null;
    if (xcapBtn) {
      var xcapChipEl = xcapBtn.closest('.kp-xcap-chip');
      var xcapSize = xcapChipEl ? xcapChipEl.dataset.xcapSize : null;
      var delta = parseInt(xcapBtn.dataset.xcapDelta, 10);
      // Never gate this on cartMutating — it's a synchronous local update
      // (no network), so gating it silently dropped every tap that landed
      // while the previous one's /cart round-trip was still in flight (a
      // rapid tapper saw maybe 1 in 5 taps register). commitPendingExtras
      // still self-guards against overlapping requests; taps that stack up
      // during that window get flushed by the trailing re-commit at the
      // end of commitPendingExtras.
      var willCommitNow = !cartMutating;
      changePendingExtraQty(xcapSize, delta, willCommitNow);
      // Commits immediately — this drawer's cart list is right there above
      // the tap, so there's nothing ambiguous about writing straight to
      // /cart (no separate CTA here, unlike the PDP module).
      commitPendingExtras();
      return;
    }

    var pgSgBtn   = e.target.closest('.kp-pg-sg-btn');
    var pgSgClose = e.target.closest('.kp-pg-sg-close');
    if (pgSgClose) {
      var popup = pgSgClose.closest('.kp-pg-sg-popup');
      if (popup) popup.classList.remove('is-open');
      return;
    }
    if (pgSgBtn) {
      var wrap = pgSgBtn.closest('.kp-pg-sg-wrap');
      var pop  = wrap && wrap.querySelector('.kp-pg-sg-popup');
      if (pop) {
        var isOpen = pop.classList.contains('is-open');
        document.querySelectorAll('.kp-pg-sg-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
        if (!isOpen) pop.classList.add('is-open');
      }
      return;
    }
    if (!e.target.closest('.kp-pg-sg-wrap')) {
      document.querySelectorAll('.kp-pg-sg-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }
  });

  // Hydrate the badge from the real cart state at load (liquid already
  // rendered the initial count/pulse, this just keeps it in sync with any
  // client-side-only cart changes from other tabs/pages in this session).
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { lastCart = cart; applyCartState(cart); })
    .catch(function () {});

  // ── SET CARD — inline second-cap-size selector + Add to Cart, homepage
  // only. Lets a visitor pick the second cap size and buy the Set without
  // leaving the homepage. Reuses findSetVariant/selectedColour/lastCart/
  // applyCartState/openCartDrawer already set up above for the drawer.
  // Mirrors the PDP's own chip-toggle and Add-Set-to-Cart/View-Cart CTA
  // logic (assets/product-kindred-set.js) so the two stay consistent.
  // See docs/superpowers/specs/2026-08-05-homepage-set-card-inline-add-to-
  // cart-design.md for the full design.
  var setChosenSize = null;
  // .kp-chip-f.kp-chip is the PDP's real second-cap-size chip markup,
  // reused verbatim on the homepage (see the liquid template) — the
  // locked Adult chip carries only .kp-chip-f (no .kp-chip), so this
  // selector naturally excludes it without needing a :not() guard.
  var setChoiceChips = document.querySelectorAll('.kp-chip-f.kp-chip');
  var setCtaLinkEls  = [document.getElementById('kh-set-cta-link'), document.getElementById('kh-sticky-cta-link')];
  var setCtaAtcEls   = [document.getElementById('kh-set-cta-atc'),  document.getElementById('kh-sticky-cta-atc')];
  // The "now" price only — .kh-sticky-price also holds a <s>$was</s> when
  // a compare-at price is active (see the liquid); overwriting the whole
  // container's textContent would silently wipe that strikethrough out.
  var stickyPriceEl  = document.getElementById('kh-sticky-price-now');

  // Three states, same precedence as the PDP's updateCTA(): setInCart wins
  // outright (always "View Cart" once the Set is in the cart, regardless
  // of chip state); otherwise it's "Add Set to Cart" once a size is picked,
  // or the plain "Shop the Set" link before that.
  function syncSetCtaState() {
    if (!setCtaAtcEls.length) return;
    var mode = setInCart ? 'view-cart' : (setChosenSize ? 'add' : 'link');
    setCtaLinkEls.forEach(function (el) { if (el) el.hidden = mode !== 'link'; });
    setCtaAtcEls.forEach(function (el) {
      if (!el) return;
      el.hidden = mode === 'link';
      if (mode === 'view-cart') {
        el.textContent = 'View Cart';
        el.dataset.mode = 'view-cart';
      } else if (mode === 'add') {
        el.textContent = 'Add Set to Cart';
        el.dataset.mode = 'add';
      }
    });
    // Ported from the PDP's syncStickyCta fix — .kh-sticky-price was static
    // liquid output ({{ hp_price }}) and never updated, always showing the
    // bare Set price no matter how many extra caps were staged in the
    // module below it. Recomputed here so it matches what tapping the
    // button next to it will actually add/has added.
    if (stickyPriceEl) {
      var total = setInCart
        ? (lastCart ? lastCart.total_price / 100 : PRICES.set)
        : PRICES.set + pendingExtrasTotal() * PRICES.extraCap;
      stickyPriceEl.textContent = '$' + Math.round(total);
    }
  }

  setChoiceChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      // Toggle: tapping the already-active chip deselects it (back to
      // white/unselected, CTA reverts to the "Shop the Set" link) — same
      // as the PDP's second-cap-size chips.
      var isActive = chip.classList.contains('is-active');
      setChoiceChips.forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });
      if (!isActive) {
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        setChosenSize = chip.dataset.size;
      } else {
        setChosenSize = null;
      }
      syncSetCtaState();
    });
  });

  setCtaAtcEls.forEach(function (btn) {
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.dataset.mode === 'view-cart') {
        if (lastCart) {
          openCartDrawer(lastCart);
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(openCartDrawer).catch(function () {});
        }
        return;
      }
      if (!setChosenSize) return;
      var variant = findSetVariant(selectedColour, setChosenSize);
      if (!variant) return;
      // Same loading treatment as the PDP's ATC button: .kp-atc-spinner
      // and its @keyframes already ship in product-kindred-set.css
      // (loaded on this page), so this is a straight visual match, not a
      // reimplementation.
      btn.disabled = true;
      btn.classList.add('is-adding');
      btn.innerHTML = '<span class="kp-atc-spinner" aria-hidden="true"></span>Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      }).then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (data) { throw new Error(data.description || data.message || 'Could not add to cart.'); });
      }).then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        lastCart = cart;
        applyCartState(cart);
        openCartDrawer(cart);
        if (typeof gtag === 'function') gtag('event', 'add_to_cart', { event_category: 'ecommerce', value: PRICES.set });
      }).catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        btn.textContent = 'Try again';
        setTimeout(function () { syncSetCtaState(); }, 2500);
      });
    });
  });
})();
